<template>
  <div class="bespread-wrap module-layer4">
    <div class="screen-container">
      <div
        class="cnt "
       
      >
        <img
          :src="require('../../assets/img/layer4/title/ttt-' + lang + '.png')"
          alt=""
          srcset=""
          class="title"
        />
        <div class="r-cnt">
          <swiper :options="featuresOptions" ref="featuresSwiper">
            <swiper-slide v-for="idx in 13" :key="idx">
              <div class="img-size">
                <img
                  :src="
                    require('../../assets/img/layer4/ban-' +
                      lang +
                      '/' +
                      idx +
                      '.jpg')
                  "
                  alt=""
                  srcset=""
                />
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev-role"></div>
          <div class="swiper-button-next-role"></div>
          <div class="swiper-pagination-media"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["language", "changeLang"],

  data() {
    return {
      lang: localStorage.getItem("sof_locale") || "en",
      featuresOptions: {
        effect: "coverflow",
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper

        allowTouchMove: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 10,
          depth: 160,
          modifier: 2,
          slideShadows: true
        },
        pagination: {
          el: ".swiper-pagination-media",
          clickable: true,
          bulletClass: "custom-bullet",
          bulletActiveClass: "custom-bullet-active"
        },
        navigation: {
          nextEl: ".swiper-button-next-role",
          prevEl: ".swiper-button-prev-role"
        }
      }
    };
  },
  watch: {
    // 监听到父组件传递过来的数据后，加工一下，
    // 存到data中去，然后在页面上使用
    language(newVal, oldVal) {
      this.lang = newVal;
    },
    changeLang(newVal, oldVal) {
      const fswiper = this.$refs.featuresSwiper.swiper;

      if (fswiper) {
        this.$nextTick(() => {
          fswiper.loopDestroy();
          fswiper.loopCreate();
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.module-layer4 {
  // pointer-events: none;

  .screen-container {
    background-image: url("../../assets/img/layer4/bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    .cnt {
      position: relative;
      text-align: center;
      padding-top: 4vw;
    }
    .title {
      width: 660px;
      height: auto;
    }
    .r-cnt {
      width: 1100px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);

      .swiper-slide {
        width: 80%;
        height: 100%;

        .img-size {
          width: 939px;
          height: 535px;
          background-image: url("../../assets/img/layer4/gd-hbimg.png");
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          position: relative;

          img {
            width: calc(100% - 20px);
            height: calc(100% - 20px);
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }

      .swiper-button-prev-role:after,
      .swiper-button-next-role:after {
        display: none;
      }

      .swiper-button-prev-role {
        background: url("../../assets/img/layer4/prev.png") no-repeat top;
        background-size: 100% 100%;
        width: 48px;
        height: 58px;
        top: 50%;
        position: absolute;
        z-index: 1;
      }

      .swiper-button-next-role {
        background: url("../../assets/img/layer4/next.png") no-repeat top;
        background-size: 100% 100%;
        width: 48px;
        height: 58px;
        top: 50%;
        right: 0;
        position: absolute;
        z-index: 1;
      }
      /deep/ .swiper-pagination-media {
        position: absolute;
        bottom: -3vw;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 17px;
        left: 50%;
        transform: translateX(-50%);
        cursor: pointer;
        .custom-bullet {
          display: inline-block;

          width: 23px;
          height: 23px;
          background: url("../../assets/img/layer4/media-icon.png") no-repeat
            top;
          background-size: 100% 100%;
        }

        .custom-bullet-active {
          background: url("../../assets/img/layer4/media-icon-active.png")
            no-repeat top;
          background-size: 100% 100%;
          width: 38px;
          height: 37px;
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .module-layer4 {
    .cnt {
      top: 7.5vw !important;
    }
  }
}
@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .module-layer4 {
    .cnt {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer4.vue